import React, { useState } from "react";
import { Badge } from "../../../../../ui/badge";

export default function EvaluationTab({ criteria }) {
  const [showAllCriticalAreas, setShowAllCriticalAreas] = useState(false);

  if (!criteria || criteria.length === 0) {
    return (
      <div className="flex justify-center items-center flex-col space-y-3 py-16">
        <img src="/images/coming-soon.svg" alt="No data" className="w-32 h-32" />
        <p className="text-lg text-gray-500">No evaluation data yet</p>
      </div>
    );
  }

  const criticalAreas = criteria.filter((item) => item.score < 60);
  const displayedCriticalAreas = showAllCriticalAreas ? criticalAreas : criticalAreas.slice(0, 3);
  const hasMoreCriticalAreas = criticalAreas.length > 3;

  const getScoreColor = (score) => {
    if (score >= 80)
      return "bg-green-100 dark:bg-[#053321] text-green-700 border-green-200 dark:border-[#085D3A]";
    if (score >= 60) return "bg-yellow-100 text-yellow-700 border-yellow-200";
    return "bg-red-100 dark:bg-[#55160C] text-red-700 dark:text-[#FDA29B] border-red-200 dark:border-[#912018]";
  };

  return (
    <div className="space-y-4">
      {/* Critical Areas */}
      {criticalAreas.length > 0 && (
        <div>
          <h3 className="text-sm font-semibold text-[#414651] dark:text-[#CECFD2] mb-3">
            Critical areas to improve
          </h3>
          <div className="flex flex-row flex-wrap gap-2 border-b border-[#EAECF0] dark:border-[#22262F] pb-4">
            {displayedCriticalAreas.map((item) => (
              <div key={item.name} className="flex items-center gap-2">
                <div className="w-1.5 h-1.5 bg-red-500 rounded-full flex-shrink-0"></div>
                <span className="text-xs text-[#414651] dark:text-[#CECFD2] font-medium">{item.name}</span>
                <Badge className="bg-[#FEF3F2] dark:bg-[#55160C] text-[#B42318] dark:text-[#FDA29B] border-[#FECDCA] dark:border-[#912018] text-xs font-medium">
                  {item.score}/100
                </Badge>
                {/* <div className="h-full border-b border-[#D5D7DA]"></div> */}
              </div>
            ))}
            {hasMoreCriticalAreas && (
              <button
                onClick={() => setShowAllCriticalAreas(!showAllCriticalAreas)}
                className="text-xs text-[#414651] dark:text-[#CECFD2] font-medium hover:underline cursor-pointer"
              >
                {showAllCriticalAreas ? "...see less" : "...see more"}
              </button>
            )}
          </div>
        </div>
      )}

      {/* Evaluation Criteria */}
      <div className="space-y-4">
        {criteria.map((item) => (
          <div key={item.name} className="border-b border-[#EAECF0] dark:border-[#1F242F] pb-4">
            <div className="flex items-center gap-4 mb-3">
              <h4 className="font-semibold text-[#414651] dark:text-[#CECFD2] text-lg">{item.name}</h4>
              <Badge variant="outline" className={getScoreColor(item.score)}>
                {item.score}/100
              </Badge>
            </div>

            {item.explanation && item.explanation.length > 0 && (
              <ul className="space-y-2">
                {item.explanation.map((line, index) => (
                  <li key={index} className="flex items-start space-x-2">
                    <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                    <span className="text-sm text-gray-700 dark:text-[#94969C]">{line}</span>
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
